import makeCrudMetaReducer from 'weego-common/src/utils/makeCrudMetaReducer';
import { actionTypes as passengersActionTypes } from '../../actions/passengers';

export default makeCrudMetaReducer(passengersActionTypes);
